module.exports = __webpack_public_path__ + "static/map-bg-0e1272734ab31203286291d77e007cf0.png";